(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-grid"] && !Shopify.designMode) return;
  try {
    
  // Contact form audience tabs + pro-only field toggle
  (function () {
    var tabs = document.querySelector('[data-audience-tabs]');
    if (!tabs) return;
    var input = tabs.querySelector('[data-audience-input]');
    var proOnly = document.querySelector('[data-pro-only]');
    tabs.querySelectorAll('.lc-contact-audience-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.dataset.audience;
        tabs.querySelectorAll('.lc-contact-audience-btn').forEach(function (b) {
          b.classList.toggle('on', b === btn);
        });
        if (input) input.value = v;
        if (proOnly) proOnly.style.display = (v === 'pro') ? '' : 'none';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Mobile menu open/close — keep tiny, no framework
  (function () {
    var open = document.querySelector('[data-mobile-menu-open]');
    var close = document.querySelector('[data-mobile-menu-close]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!open || !menu) return;
    open.addEventListener('click', function () { menu.removeAttribute('hidden'); });
    if (close) close.addEventListener('click', function () { menu.setAttribute('hidden', ''); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-detail"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const main = document.getElementById('PdpMainImage');
    document.querySelectorAll('[data-thumb]').forEach(thumb => {
      thumb.addEventListener('click', () => {
        if (main && thumb.dataset.src) main.src = thumb.dataset.src;
        document.querySelectorAll('[data-thumb]').forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
    const qty = document.querySelector('[data-qty]');
    document.querySelector('[data-qty-incr]')?.addEventListener('click', () => { if (qty) qty.value = parseInt(qty.value, 10) + 1; });
    document.querySelector('[data-qty-decr]')?.addEventListener('click', () => { if (qty) qty.value = Math.max(1, parseInt(qty.value, 10) - 1); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spaces-split"] && !Shopify.designMode) return;
  try {
    
  // CTAs with data-set-audience flip the global audience toggle before scrolling to anchor
  (function () {
    document.querySelectorAll('[data-set-audience]').forEach(function (link) {
      link.addEventListener('click', function () {
        var v = link.dataset.setAudience;
        if (window.lcAudience && v) window.lcAudience.set(v);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
